import { render, staticRenderFns } from "./ProductsDashboard.vue?vue&type=template&id=120622b3&scoped=true&"
import script from "./ProductsDashboard.vue?vue&type=script&lang=js&"
export * from "./ProductsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ProductsDashboard.scss?vue&type=style&index=0&id=120622b3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120622b3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
